import {PostLoginLoanApplicationFlowStep} from './post-login-loan-application-flow.step';
import { Injectable } from "@angular/core";

@Injectable()
export class BorrowerSummaryStep extends PostLoginLoanApplicationFlowStep {

    description(): string {
        return 'Review your application';
    }

    displayName(): string {
        return 'Quick Review';
    }

    async isStepComplete(): Promise<boolean> {
        return false;
    }

    url(): string {
        return this.createBorrowerFlowUrl('summary');
    }
}